module.exports = __webpack_public_path__ + "img/license-radio-off.4dbdaede.svg";